import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { InputMask } from 'primereact/inputmask';

import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { periods } from 'constants/dropdownOptions';
import LabelName from 'components/UI/LabelName/LabelName';
import SubText from '../FormComponenets/SubText';

export default function Time({ handleSettingsClick, item, index, isFormBuilder, isFromPreview = false }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, required, label = 'Short Text' } = item || {};

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={`form_data.${index}.time`}
          control={control}
          rules={
            isFormBuilder
              ? {}
              : {
                  required: required ? 'Required Field' : false,
                  pattern: {
                    message: 'Invalid time. 12 hour format only eg. 06:36',
                    value: /^([01]\d|2[0-3]):?([0-5]\d)?$/,
                  },
                }
          }
          render={({ field }) => (
            <InputMask
              mask="99:99"
              value={field.value}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              onChange={(e) => field.onChange(e.value)}
              placeholder="HH:MM"
              className="input-shadow me-3"
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <Controller
          name={`form_data.${index}.period`}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          defaultValue="AM"
          render={({ field }) => (
            <Dropdown
              value={field.value}
              options={periods}
              onChange={(e) => field.onChange(e.value)}
              className="input-shadow"
              style={{ width: 80, pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
      </div>
      <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      <RequiredValidation field={`form_data.${index}.time`} errors={errors} />
      <RequiredValidation field={`form_data.${index}.period`} errors={errors} />
    </div>
  );
}
